import { useMemo } from 'react';

import { useAccountPersistentStore } from '../../../modules/store/accountPersistentStore';
import { resolveTierIconColor } from './resolveTierIconColor';

export const useWalletWidgetTierColor = (headerIcon?: string): string | undefined => {
  const { memberLevelCode, memberLevelTypeCode } = useAccountPersistentStore(state => state);

  return useMemo(() => {
    if (!headerIcon) return undefined;
    return resolveTierIconColor(memberLevelTypeCode || memberLevelCode || undefined);
  }, [headerIcon, memberLevelTypeCode, memberLevelCode]);
};
